<div class="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="vat-report-dialog">
  <!-- Prüfdaten (was an VIES gesendet wurde) -->
  <div class="flex flex-col gap-3">
    <h3 class="font-semibold text-surface-700 dark:text-surface-200">
      {{ 'address.vat-report-section-request' | translate }}
    </h3>
    <phx-labeled-data [label]="'address.vat-field-requested-id' | translate">{{ verification.requestedVatId }}</phx-labeled-data>
    <phx-labeled-data [label]="'common.name' | translate">{{ verification.recipient }}</phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-street' | translate">{{ verification.street }} {{ verification.streetNumber }}</phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-postal-code' | translate">{{ verification.postalCode }}</phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-city' | translate">{{ verification.city }}</phx-labeled-data>
    <phx-labeled-data [label]="'common.country' | translate">{{ verification.countryIso }}</phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-requester' | translate">{{ verification.requesterVatId }}</phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-check-type' | translate">{{ checkTypeLabel() | translate }}</phx-labeled-data>
  </div>

  <!-- Rückgabe (VIES-Antwort) -->
  <div class="flex flex-col gap-3">
    <h3 class="font-semibold text-surface-700 dark:text-surface-200">
      {{ 'address.vat-report-section-response' | translate }}
    </h3>
    <phx-labeled-data [label]="'address.vat-field-result' | translate">
      <p-tag styleClass="mt-2" [severity]="resultSeverity()" [value]="resultLabel() | translate" />
    </phx-labeled-data>
    <phx-labeled-data [label]="'common.name' | translate">
      <p-tag styleClass="mt-2" [severity]="matchSeverity(verification.nameMatch)" [value]="matchLabel(verification.nameMatch) | translate" />
    </phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-street' | translate">
      <p-tag styleClass="mt-2" [severity]="matchSeverity(verification.streetMatch)" [value]="matchLabel(verification.streetMatch) | translate" />
    </phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-postal-code' | translate">
      <p-tag styleClass="mt-2" [severity]="matchSeverity(verification.postalCodeMatch)" [value]="matchLabel(verification.postalCodeMatch) | translate" />
    </phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-city' | translate">
      <p-tag styleClass="mt-2" [severity]="matchSeverity(verification.cityMatch)" [value]="matchLabel(verification.cityMatch) | translate" />
    </phx-labeled-data>
    <phx-labeled-data [label]="'address.vat-field-company-type-match' | translate">
      <p-tag styleClass="mt-2" [severity]="matchSeverity(verification.companyTypeMatch)" [value]="matchLabel(verification.companyTypeMatch) | translate" />
    </phx-labeled-data>
    @if (verification.viesName) {
      <phx-labeled-data [label]="'address.vat-field-vies-name' | translate">{{ verification.viesName }}</phx-labeled-data>
    }
    @if (verification.viesAddress) {
      <phx-labeled-data [label]="'address.vat-field-vies-address' | translate">{{ verification.viesAddress }}</phx-labeled-data>
    }
    @if (verification.errorDetail) {
      <phx-labeled-data [label]="'address.vat-field-error-detail' | translate">{{ verification.errorDetail }}</phx-labeled-data>
    }
  </div>
</div>

<!-- Rechtsnachweis -->
<hr class="my-4 border-surface-200 dark:border-surface-700" />
<div class="flex flex-col sm:flex-row gap-4">
  <phx-labeled-data [label]="'address.vat-field-consultation' | translate">{{ verification.requestIdentifier || '—' }}</phx-labeled-data>
  <phx-labeled-data [label]="'address.vat-field-request-date' | translate">{{ requestDate() | localeDate: 'medium' }}</phx-labeled-data>
</div>

<ng-template phxDialogButtons>
  <div class="flex justify-end">
    <p-button severity="secondary" [label]="'common.close' | translate" (onClick)="close()" />
  </div>
</ng-template>
